export default __webpack_public_path__ + "static/media/img-0518-croatia-premium-face.d893e36e.png";